module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.d3028d93.eot";